export default __webpack_public_path__ + "static/media/gura-giga-novels.39714140.png";